import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from '@babel/runtime/regenerator';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import cloudinary from 'cloudinary-core';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import fetch from 'isomorphic-unfetch';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function useImage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      cloud_name = _ref.cloud_name;

  var cld = cloudinary.Cloudinary["new"]({
    cloud_name: cloud_name
  }, {
    secure: true
  });

  if (!cloud_name) {
    throw new Error("Must enter a cloud name");
  }

  var _React$useState = useState({
    public_id: '',
    transform_options: {}
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      imageOptions = _React$useState2[0],
      setImageOptions = _React$useState2[1];

  var _useQuery = useQuery(imageOptions && ["".concat(imageOptions.public_id, "-url"), imageOptions], /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, imageOptions) {
      var image;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return cld.url(imageOptions.public_id, _objectSpread({}, imageOptions.transform_options));

            case 2:
              image = _context.sent;
              return _context.abrupt("return", image);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()),
      data = _useQuery.data,
      status = _useQuery.status,
      error = _useQuery.error;

  function getImage() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        public_id = _ref3.public_id,
        transform_options = _ref3.transform_options;

    if (!public_id) {
      throw new Error("Must provide a public id of your asset");
    }

    if ((transform_options.hasOwnProperty('width') || transform_options.hasOwnProperty('height')) && !transform_options.hasOwnProperty('crop')) {
      transform_options.crop = 'scale';
    }

    if (!transform_options.hasOwnProperty('fetchFormat')) {
      transform_options.fetchFormat = 'auto';
    }

    return setImageOptions({
      public_id: public_id,
      transform_options: transform_options
    });
  }

  return {
    getImage: getImage,
    data: data,
    status: status,
    error: error
  };
}

function useUpload() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      endpoint = _ref.endpoint;

  if (!endpoint) {
    throw new Error("Must provide an endpoint to upload");
  }

  var _useMutation = useMutation( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var file, uploadOptions, res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              file = _ref2.file, uploadOptions = _ref2.uploadOptions;
              _context.next = 3;
              return fetch(endpoint, {
                method: 'POST',
                body: JSON.stringify({
                  eager: uploadOptions.eager || {},
                  tags: _toConsumableArray(uploadOptions.tags),
                  public_id: uploadOptions.public_id,
                  file: file
                })
              });

            case 3:
              res = _context.sent;
              return _context.abrupt("return", res.json());

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      upload = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      data = _useMutation2$.data,
      status = _useMutation2$.status,
      error = _useMutation2$.error;

  return {
    upload: upload,
    data: data,
    status: status,
    error: error
  };
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function useVideo(_ref) {
  var cloud_name = _ref.cloud_name;
  var cld = cloudinary.Cloudinary["new"]({
    cloud_name: cloud_name
  }, {
    secure: true
  });

  var _React$useState = useState({
    public_id: '',
    transform_options: {}
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      videoOptions = _React$useState2[0],
      setVideoOptions = _React$useState2[1];

  var _useQuery = useQuery(videoOptions && ["".concat(videoOptions.public_id, "-url"), videoOptions], /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, videoOptions) {
      var video;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              video = cld.video_url(videoOptions.public_id, _objectSpread$1({}, videoOptions.transform_options));
              return _context.abrupt("return", video);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()),
      data = _useQuery.data,
      status = _useQuery.status,
      error = _useQuery.error;

  function getVideo(_ref3) {
    var public_id = _ref3.public_id,
        transform_options = _ref3.transform_options;
    return setVideoOptions({
      public_id: public_id,
      transform_options: transform_options
    });
  }

  return {
    getVideo: getVideo,
    data: data,
    status: status,
    error: error
  };
}

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function useGif(_ref) {
  var cloud_name = _ref.cloud_name;
  var cld = cloudinary.Cloudinary["new"]({
    cloud_name: cloud_name
  }, {
    secure: true
  });

  var _React$useState = useState({
    public_id: '',
    transform_options: {}
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      gifOptions = _React$useState2[0],
      setGifOptions = _React$useState2[1];

  var _useQuery = useQuery(gifOptions && ["".concat(gifOptions.public_id, "-url"), gifOptions], /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, gifOptions) {
      var gif;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              gif = cld.video_url("".concat(gifOptions.public_id, ".gif"), _objectSpread$2(_objectSpread$2({}, gifOptions.transform_options), {}, {
                flags: "animated",
                fetchFormat: "auto",
                effect: "loop"
              }));
              return _context.abrupt("return", gif);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()),
      data = _useQuery.data,
      status = _useQuery.status,
      error = _useQuery.error;

  function getGif(_ref3) {
    var public_id = _ref3.public_id,
        transform_options = _ref3.transform_options;
    return setGifOptions({
      public_id: public_id,
      transform_options: transform_options
    });
  }

  return {
    getGif: getGif,
    data: data,
    status: status,
    error: error
  };
}

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function useSearch() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      endpoint = _ref.endpoint;

  if (!endpoint) {
    throw new Error("Must provide an endpoint to search");
  }

  var _useMutation = useMutation( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(searchBody) {
      var res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(endpoint, {
                method: "POST",
                body: JSON.stringify(_objectSpread$3({}, searchBody))
              });

            case 2:
              res = _context.sent;
              return _context.abrupt("return", res.json());

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }()),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      search = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      data = _useMutation2$.data,
      status = _useMutation2$.status,
      error = _useMutation2$.error;

  return {
    search: search,
    data: data,
    status: status,
    error: error
  };
}

function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function useAudio(_ref) {
  var cloud_name = _ref.cloud_name;
  var cld = cloudinary.Cloudinary["new"]({
    cloud_name: cloud_name
  });

  var _React$useState = useState({
    public_id: '',
    transform_options: {}
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      audioOptions = _React$useState2[0],
      setAudioOptions = _React$useState2[1];

  var _useQuery = useQuery(audioOptions && ["".concat(audioOptions.public_id, "-url"), audioOptions], /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, audioOptions) {
      var audio;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              audio = cld.video_url("".concat(audioOptions.public_id, ".mp3"), _objectSpread$4({}, audioOptions.transform_options));
              return _context.abrupt("return", audio);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()),
      data = _useQuery.data,
      status = _useQuery.status,
      error = _useQuery.error;

  function getAudio(_ref3) {
    var public_id = _ref3.public_id,
        transform_options = _ref3.transform_options;
    return setAudioOptions({
      public_id: public_id,
      transform_options: transform_options
    });
  }

  return {
    getAudio: getAudio,
    data: data,
    status: status,
    error: error
  };
}

function useCloudinary() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      cloud_name = _ref.cloud_name;

  var cld = cloudinary.Cloudinary["new"]({
    cloud_name: cloud_name
  }, {
    secure: true
  });
  return {
    cld: cld,
    cloudinaryCore: cloudinary
  };
}

export { useAudio, useCloudinary, useGif, useImage, useSearch, useUpload, useVideo };